<script>
	/***
	 * Component to wrap audio player and manage page audio in eBooks
	 *	@property src
	 ***/
	const analyticsUtilities = require('utilities/analyticsUtilities');
	const EBOOK_AUDIO_PLAY = analyticsUtilities.events.EBOOK_AUDIO_PLAY;
	const EBOOK_AUDIO_PAUSE = analyticsUtilities.events.EBOOK_AUDIO_PAUSE;
	const EBOOK_AUDIO_COMPLETE = analyticsUtilities.events.EBOOK_AUDIO_COMPLETE;

	module.exports = {
		props: {
			src: {
				type: String
			},
			startTime: {
				type: Number
			},
			endTime: {
				type: Number
			},
			eventData: {
				default: null
			}
		},
		components: {
			'audio-player': require('components/audio-player.vue').default
		},
		data() {
			return {
				isPlaying: false,
				EBOOK_AUDIO_PLAY,
				EBOOK_AUDIO_PAUSE,
				EBOOK_AUDIO_COMPLETE
			};
		},
		watch: {
			startTime(val) {
				const player = this.$refs.audioPlayer;

				if (player) {
					this.pause();
					player.setCurrentTime(val);
				}
			}
		},
		methods: {
			play() {
				const audio = this.$refs.audioPlayer;
				const audioEl = audio.getPlayer();
				const currentTime = audioEl.currentTime;
				const startTime = this.startTime;
				const endTime = this.endTime;

				if (currentTime >= endTime || currentTime <= startTime) {
					audioEl.currentTime = this.startTime;
				}

				if (!audio.paused) {
					this.pause();
					this.firePauseEvent();
				} else {
					this.isPlaying = true;
					audio.play();
				}
			},
			pause() {
				const audio = this.$refs.audioPlayer;

				audio.pause();
				this.isPlaying = false;
			},
			onTimeUpdate() {
				const audio = this.$refs.audioPlayer;
				const audioEl = audio.getPlayer();

				if (audioEl.currentTime >= this.endTime && !audio.paused) {
					this.pause();
					this.firePauseEvent(true);
					setTimeout(() => (audioEl.currentTime = this.startTime), 1);
				}
			},
			firePauseEvent(endOfPage) {
				let player = this.$refs.audioPlayer;
				let event = EBOOK_AUDIO_PAUSE;

				if (endOfPage) {
					event = EBOOK_AUDIO_COMPLETE;
				}

				player.fireEvent(event);
			}
		}
	};
</script>
<style lang="scss">
	@import 'config/colors';
	.ebook-audio-player {
		button {
			appearance: none;
			background: none;
			border: none;
			font-size: 3rem;
			cursor: pointer;
			z-index: 2;
			color: $c-blue;
			position: relative;
			&:hover {
				color: lighten($c-blue, 5%);
			}
			> i {
				margin-top: -0.1rem;
				position: absolute;
				&.fa-circle {
					color: $c-blue-lighter;
				}
			}
		}
		.audio-player {
			display: none;
		}
	}
</style>
<template>
	<div class="ebook-audio-player">
		<button
			@click="play"
			:aria-label="isPlaying ? 'Pause' : 'Play'">
			<i
				class="fa-solid fa-circle"
				aria-hidden="true"></i>
			<i
				class="fa-regular"
				:class="{
					'fa-circle-play': !isPlaying,
					'fa-circle-pause': isPlaying
				}"
				aria-hidden="true"></i>
		</button>
		<audio-player
			ref="audioPlayer"
			:src="src"
			:event-data="eventData"
			:fire-pause-event="false"
			:audio-play-event-name="EBOOK_AUDIO_PLAY"
			:audio-pause-event-name="EBOOK_AUDIO_PAUSE"
			:audio-complete-event-name="EBOOK_AUDIO_COMPLETE"
			@timeupdate="onTimeUpdate">
		</audio-player>
	</div>
</template>
